export default __webpack_public_path__ + "static/media/logo_pdf.c132e03d.png";